/*!
 * strength.js
 * Original author: @aaronlumsden
 * Further changes, comments: @aaronlumsden
 * Licensed under the MIT license
 */
const Strength = () => {
  const pluginName = 'strength';
  const defaults = {
    strengthClass: 'strength',
    strengthMeterClass: 'strength_meter',
    strengthButtonClass: 'button_strength',
    strengthButtonText: 'Show password',
    strengthButtonTextToggle: 'Hide password',
  };

  function Plugin(element, options) {
    this.element = element;
    this.$elem = $(this.element);
    this.options = $.extend({}, defaults, options);
    this.defaults = defaults;
    this.name = pluginName;
    this.init();
  }

  Plugin.prototype = {

    init() {
      function getTotal(total, thisId) {
        const thismeter = $(`div[data-meter="${thisId}"]`);
        if (total > 64) {
          thismeter.removeClass();
          thismeter.addClass('strong').find('span').html("you're trying too hard, good for you");
        } else if (total < 6) {
          thismeter.removeClass();
          thismeter.addClass('veryweak').find('span').html('too weak');
        } else if (total < 8) {
          thismeter.removeClass();
          thismeter.addClass('weak').find('span').html('still quite weak');
        } else if (total < 10) {
          thismeter.removeClass();
          thismeter.addClass('medium').find('span').html('almost strong enough');
        } else if (total < 15) {
          thismeter.removeClass();
          thismeter.addClass('strong').find('span').html('strong enough');
        } else {
          thismeter.removeClass();
          thismeter.addClass('strong').find('span').html('looks quite strong');
        }
      }

      function checkStrength(thisval, thisId) {
        getTotal(thisval.length, thisId);
      }

      let isShown = false;
      const { strengthButtonText } = this.options;
      const { strengthButtonTextToggle } = this.options;

      const thisId = this.$elem.attr('id');

      this.$elem.addClass(this.options.strengthClass).attr('data-password', thisId).after(`<input style="display:none" class="${this.options.strengthClass}" data-password="${thisId}" type="text" name="" value=""><div class="${this.options.strengthMeterClass}"><div data-meter="${thisId}"><span></span></div></div>`);

      this.$elem.bind('keyup keydown', () => {
        const thisVal = $(`#${thisId}`).val();
        $(`input[type="text"][data-password="${thisId}"]`).val(thisVal);
        checkStrength(thisVal, thisId);
      });

      $(`input[type="text"][data-password="${thisId}"]`).bind('keyup keydown', () => {
        const thisVal = $(`input[type="text"][data-password="${thisId}"]`).val();
        $(`input[type="password"][data-password="${thisId}"]`).val(thisVal);
        checkStrength(thisVal, thisId);
      });

      $(document.body).on('click', `.${this.options.strengthButtonClass}`, (e) => {
        e.preventDefault();
        const thisClass = `hide_${$(this).attr('class')}`;

        if (isShown) {
          $(`input[type="text"][data-password="${thisId}"]`).hide();
          $(`input[type="password"][data-password="${thisId}"]`).show().focus();
          $(`a[data-password-button="${thisId}"]`).removeClass(thisClass).html(strengthButtonText);
          isShown = false;
        } else {
          $(`input[type="text"][data-password="${thisId}"]`).show().focus();
          $(`input[type="password"][data-password="${thisId}"]`).hide();
          $(`a[data-password-button="${thisId}"]`).addClass(thisClass).html(strengthButtonTextToggle);
          isShown = true;
        }
      });
    },
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function initPlugins(options) {
    return this.each(function initPlugin() {
      if (!$.data(this, `plugin_${pluginName}`)) {
        $.data(this, `plugin_${pluginName}`, new Plugin(this, options));
      }
    });
  };
};

export default Strength();
